import createDailyAgendaWidget from './createDailyAgendaWidget';
import type { EditorAPI } from '@/editorAPI';

export default ({ editorAPI }: { editorAPI: EditorAPI }) =>
  createDailyAgendaWidget({
    editorAPI,
  });
